module.exports = __webpack_public_path__ + "static/diego-ff8d286f5e01a8796619b9a4057f8e77.jpg";